import { Component } from '@angular/core';
import { LoginService } from './services/login.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'Operations-Sublime-Expeditions';

  constructor( private loginService: LoginService){}

  Cargado = () => this.loginService.Cargado;
}
